import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { goToPage } from '@epi-actions/navigation';
import { routerPaths } from '@epi-constants/routerPaths';
import { addLocale, getLocale, removeLocale } from '@epi-helpers/UrlHelpers';
import {
  MANAGE_EMPLOYEES_SEARCH_NAME,
  TabsManageEmployees
} from '@epi-constants/manageEmployees';
import { useGetDetailsQuery } from '@epi-api/user';
import { useOnboardingWizard } from '@epi-shared/hooks/useOnboardingWizard';

export const useManageEmployeesTabs = () => {
  const { t } = useTranslation();
  const [showFooter, setShowFooter] = useState(false);
  const { search, pathname } = useLocation();
  const dispatch = useDispatch();
  const { data: customerData } = useGetDetailsQuery();
  const { isOnBoardingActive, flags, handleGoOnboardingPayment } =
    useOnboardingWizard();
  const hasEmployees = customerData?.isEmployeesSet;

  const locale = getLocale(pathname) || 'fi';

  const getTabPath = tabName =>
    addLocale(
      locale,
      tabName === TabsManageEmployees.massUpload
        ? routerPaths.beneficiariesHrImportHistory
        : routerPaths.beneficiaries
    );

  const handleFooterVisibility = tabName =>
    setShowFooter(tabName === TabsManageEmployees.employees);

  const handleURLChange = tabName => dispatch(goToPage(getTabPath(tabName)));

  const handleOnTabChange = tabName => {
    handleFooterVisibility(tabName);
    handleURLChange(tabName);
  };

  const urlParams = new URLSearchParams(search);
  const indexType = urlParams.get(MANAGE_EMPLOYEES_SEARCH_NAME);
  const currentPath = removeLocale(pathname).replace(/\/+$/, '') || '/';

  const defaultTabNameByPath =
    currentPath === routerPaths.beneficiariesHrImportHistory
      ? TabsManageEmployees.massUpload
      : TabsManageEmployees.employees;

  const defaultTabName =
    indexType && TabsManageEmployees[indexType]
      ? TabsManageEmployees[indexType]
      : defaultTabNameByPath;

  const footer = isOnBoardingActive
    ? {
        backText: t('components.onboarding.buttons.back'),
        submitText: t('components.onboarding.buttons.next'),
        onBack: () => {
          dispatch(goToPage(routerPaths.benefitGroups));
        },
        onSubmit: handleGoOnboardingPayment,
        disableSubmit: !flags?.isEmployeesSet,
        submitButtonWidth: '240px'
      }
    : undefined;

  return {
    footer,
    showFooter,
    handleOnTabChange,
    defaultTabName,
    hasEmployees
  };
};
